/* eslint-disable */
export default {
  flowDate: '2017-09-25',
  flowType: 'CUS-CUS-MOV',
  etmOrderNumber: '0100003657',
  salesOrderNumber: null,
  deliveryNumber: null,
  shipmentNumber: null,
  invoiceNumber: null,
  customerRefNumber: 'kllk',
  from: {
    id: '0002000220',
    name: 'Aardappelhandel De Rop N.V.',
  },
  to: {
    id: '0002000221',
    name: 'Aldi Erpe-Mere',
  },
  transporter: null,
  clearing: 'no',
  handshakeDate: null,
  handshakeStatus: '02',
  wholeSalerId: null,
  comments:
    '                                                                                                                                                                                                                                                               ',
  updateDate: '2017-09-25',
  updateTime: '11:38:32',
  updateBy: 'PRO_DEV',
  isLocked: null,
  flowLineItems: [
    {
      itemNumber: 100,
      packingId: '000000000021000002',
      packingStatus: null,
      originalQuantity: 7,
      definitiveQuantity: null,
      differenceQuantity: null,
      lineReferenceId: null,
      contentId: null,
    },
  ],
};
